document.addEventListener("DOMContentLoaded", () => {
  const input = document.getElementById("design-text");
  const preview = document.getElementById("preview-text");
  const canvas = document.getElementById("design-canvas");
  const fontSelect = document.getElementById("font-select");
  const fontSize = document.getElementById("font-size");
  const quantitySelect = document.getElementById("quantity-select");
  const designHeight = document.getElementById("design-height");
  const designWidth = document.getElementById("design-width");
  const designPrice = document.getElementById("design-price");
  const fontSizeValue = document.getElementById("font-size-value");
  const form = document.getElementById("custom-lettering-form");
  if (!input || !preview || !canvas || !fontSelect || !fontSize || !quantitySelect || !form) return;

  const appEndpoint = "https://decals-production-app-production.up.railway.app";
  const measurementEndpoint = `${appEndpoint}/measure`;
  const checkoutEndpoint = `${appEndpoint}/create-checkout`;
  const property = (id) => document.getElementById(id);
  const number = () => Math.min(12, Math.max(1, Number.parseFloat(fontSize.value) || 4));
  let posX = 0;
  let posY = 0;
  let scale = 1;
  let letterSpacing = 0;
  let lineSpacing = 1;
  let alignment = "center";
  let dragging = false;
  let lastX = 0;
  let lastY = 0;
  let measurementTimer;
  let measurementId = 0;

  function applyPosition() {
    const anchors = {
      left: { left: "8%", translateX: "0%" },
      center: { left: "50%", translateX: "-50%" },
      right: { left: "92%", translateX: "-100%" }
    };
    const anchor = anchors[alignment];
    preview.style.setProperty("left", `calc(${anchor.left} + ${posX}px)`, "important");
    preview.style.setProperty("top", `calc(50% + ${posY}px)`, "important");
    preview.style.setProperty("transform", `translate(${anchor.translateX}, -50%) scale(${scale})`, "important");
  }

  function setPrice(width) {
    const basePrice = 9.99 + Math.max(0, width - 12) * (5 / 12);
    const estimatedPrice = `$${(basePrice * Number(quantitySelect.value) * 0.85).toFixed(2)}`;
    designPrice.textContent = estimatedPrice;
    const mobilePrice = document.getElementById("mobile-price");
    if (mobilePrice) mobilePrice.textContent = estimatedPrice;
  }

  function setCartSummary(colorName, heightText) {
    const cartSummary = document.getElementById("cart-summary");
    if (cartSummary) cartSummary.textContent = `Your selection: ${colorName} · ${heightText} tall · Qty ${quantitySelect.value}`;
  }

  function scheduleAccurateMeasurement({ text, font, letterHeight, colorName }) {
    window.clearTimeout(measurementTimer);
    const thisMeasurement = ++measurementId;
    if (!text.trim()) return;

    measurementTimer = window.setTimeout(async () => {
      try {
        const response = await fetch(measurementEndpoint, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ text, font, letterHeight, lineSpacing, letterSpacing })
        });
        if (!response.ok) return;
        const result = await response.json();
        if (thisMeasurement !== measurementId) return;

        const widthText = `${result.widthIn.toFixed(1)}"`;
        const heightText = `${result.heightIn.toFixed(1)}"`;
        designWidth.textContent = widthText;
        designHeight.textContent = heightText;
        property("property-width").value = widthText;
        setPrice(result.widthIn);
        setCartSummary(colorName, heightText);
      } catch (_error) {
        // The storefront stays usable if the measurement service is briefly unavailable.
      }
    }, 250);
  }

  function update() {
    const height = number();
    const text = input.value.trim();
    if (!text) {
    designPrice.textContent = "$0.00";

    const mobilePrice = document.getElementById("mobile-price");
    if (mobilePrice) {
        mobilePrice.textContent = "$0.00";
    }

    designHeight.textContent = "—";
    designWidth.textContent = "—";

    return;
}
    const selected = document.querySelector(".color-btn.active");
    const colorName = selected ? selected.dataset.name : "Matte Black";
    const colorHex = selected ? selected.dataset.color : "#1f1f1f";
    const fontName = fontSelect.options[fontSelect.selectedIndex].text;

    fontSize.value = height.toFixed(1);

preview.textContent = text || "Your text will appear here";

// Force the browser to calculate the new text size before measuring it

preview.style.fontFamily = fontSelect.value;
preview.style.setProperty("font-size", `${height * 18}px`, "important");
preview.style.setProperty("letter-spacing", `${letterSpacing}px`, "important");
preview.style.setProperty("line-height", lineSpacing, "important");

fontSizeValue.textContent = `${height.toFixed(1)}"`;

    const estimatedWidth = preview.scrollWidth / 18;
    const estimatedHeight = height * (1 + Math.max(0, (text || "Your text will appear here").split("\n").length - 1) * lineSpacing);
    const estimatedWidthText = `${estimatedWidth.toFixed(1)}"`;
    const estimatedHeightText = `${estimatedHeight.toFixed(1)}"`;

    designWidth.textContent = estimatedWidthText;
    designHeight.textContent = estimatedHeightText;
    setPrice(estimatedWidth);

    scale = Math.min(1, Math.max(0.1, (canvas.clientWidth - 48) / Math.max(preview.scrollWidth, 1)));
    applyPosition();

    property("property-custom-text").value = input.value;
    property("property-font").value = fontName;
    property("property-height").value = height.toFixed(1);
    property("property-width").value = estimatedWidthText;
    property("property-line-spacing").value = lineSpacing.toFixed(1);
    property("property-letter-spacing").value = String(letterSpacing);
    property("property-quantity").value = quantitySelect.value;
    property("property-color").value = colorName;
    property("property-color-hex").value = colorHex;

    const selectedColor = document.getElementById("color-selected");
    if (selectedColor) selectedColor.textContent = colorName;
    setCartSummary(colorName, estimatedHeightText);
    scheduleAccurateMeasurement({ text: input.value, font: fontName, letterHeight: height, colorName });
  }

  function startDrag(x, y) {
    dragging = true;
    lastX = x;
    lastY = y;
    preview.classList.add("is-dragging");
  }

  function drag(x, y) {
    if (!dragging) return;
    posX += x - lastX;
    posY += y - lastY;
    lastX = x;
    lastY = y;
    applyPosition();
  }

  function endDrag() {
    dragging = false;
    preview.classList.remove("is-dragging");
  }

  preview.addEventListener("pointerdown", (event) => {
    event.preventDefault();
    preview.setPointerCapture(event.pointerId);
    startDrag(event.clientX, event.clientY);
  });

  preview.addEventListener("pointermove", (event) => drag(event.clientX, event.clientY));
  preview.addEventListener("pointerup", endDrag);
  preview.addEventListener("pointercancel", endDrag);

  document.getElementById("height-minus").addEventListener("click", () => {
    fontSize.value = (number() - 0.5).toFixed(1);
    update();
  });

  document.getElementById("height-plus").addEventListener("click", () => {
    fontSize.value = (number() + 0.5).toFixed(1);
    update();
  });

  [input, fontSelect, fontSize, quantitySelect].forEach((element) => {
    element.addEventListener(element === input || element === fontSize ? "input" : "change", update);
  });

  document.querySelectorAll(".color-btn").forEach((button) => button.addEventListener("click", () => {
    document.querySelectorAll(".color-btn").forEach((item) => item.classList.remove("active"));
    button.classList.add("active");
    preview.style.setProperty("color", button.dataset.color, "important");

    const previewWindow = document.querySelector(".preview-window");
    const isWhite = /White/.test(button.dataset.name);
    previewWindow.classList.toggle("is-light-vinyl", isWhite);
    previewWindow.style.setProperty("background-color", isWhite ? "#7b7b7b" : "#f7f8fa", "important");
    previewWindow.style.setProperty("border-color", isWhite ? "#666" : "#e5e7eb", "important");

    update();

    const colorPickerModal = document.getElementById("color-picker-modal");
    if (colorPickerModal) colorPickerModal.hidden = true;
    document.body.classList.remove("color-picker-open");
  }));

  const colorPicker = document.getElementById("color-picker-modal");
  const openColorPicker = document.getElementById("open-color-picker");

  if (openColorPicker && colorPicker) {
    openColorPicker.addEventListener("click", () => {
      colorPicker.hidden = false;
      document.body.classList.add("color-picker-open");
    });
  }

  document.querySelectorAll("[data-close-color-picker]").forEach((button) => button.addEventListener("click", () => {
    if (colorPicker) colorPicker.hidden = true;
    document.body.classList.remove("color-picker-open");
  }));

  document.querySelectorAll("[data-align]").forEach((button) => button.addEventListener("click", () => {
    document.querySelectorAll("[data-align]").forEach((item) => item.classList.remove("active"));
    button.classList.add("active");
    alignment = button.dataset.align;
    posX = 0;
    applyPosition();
  }));

  document.querySelectorAll(".spacing-btn").forEach((button) => button.addEventListener("click", () => {
    const change = Number(button.dataset.change);

    if (button.dataset.spacing === "letter") {
      letterSpacing = Math.min(20, Math.max(-10, letterSpacing + change));
      document.getElementById("letter-spacing-value").textContent = letterSpacing;
    } else {
      lineSpacing = Math.min(2.5, Math.max(0.7, Number((lineSpacing + change).toFixed(1))));
      document.getElementById("line-spacing-value").textContent = lineSpacing.toFixed(1);
    }

    update();
  }));

  document.querySelectorAll("[data-quick-height]").forEach((button) => button.addEventListener("click", () => {
    fontSize.value = button.dataset.quickHeight;
    document.querySelectorAll("[data-quick-height]").forEach((item) => item.classList.toggle("active", item === button));
    update();
  }));

  document.getElementById("preview-reset").addEventListener("click", () => {
    posX = 0;
    posY = 0;
    letterSpacing = 0;
    lineSpacing = 1;
    alignment = "center";

    document.getElementById("letter-spacing-value").textContent = "0";
    document.getElementById("line-spacing-value").textContent = "1.0";
    document.querySelectorAll("[data-align]").forEach((item) => item.classList.toggle("active", item.dataset.align === "center"));

    preview.style.textAlign = "center";
    update();
  });

  document.getElementById("design-start-over").addEventListener("click", () => {
    input.value = "";
    fontSelect.selectedIndex = 0;
    fontSize.value = "4";
    quantitySelect.value = "2";
    posX = 0;
    posY = 0;
    letterSpacing = 0;
    lineSpacing = 1;
    alignment = "center";

    document.getElementById("letter-spacing-value").textContent = "0";
    document.getElementById("line-spacing-value").textContent = "1.0";
    document.querySelectorAll("[data-align]").forEach((item) => item.classList.toggle("active", item.dataset.align === "center"));
    document.querySelectorAll("[data-quick-height]").forEach((item) => item.classList.toggle("active", item.dataset.quickHeight === "4"));

    if (colorPicker) colorPicker.hidden = true;
    document.body.classList.remove("color-picker-open");

    const defaultColor = document.querySelector('.color-btn[data-name="Matte Black"]');
    if (defaultColor) defaultColor.click();
    else update();
  });

form.addEventListener("submit", async (event) => {
  event.preventDefault();

  if (!input.value.trim()) {
    input.focus();
    alert("Please enter the lettering you would like to order.");
    return;
  }

  const selected = document.querySelector(".color-btn.active");
  const submitButtons = document.querySelectorAll('[type="submit"][form="custom-lettering-form"], #custom-lettering-form [type="submit"]');
  submitButtons.forEach((button) => {
    button.disabled = true;
    button.dataset.originalText = button.textContent;
    button.textContent = "Preparing secure checkout…";
  });

  try {
    const response = await fetch(checkoutEndpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        text: input.value,
        font: fontSelect.options[fontSelect.selectedIndex].text,
        letterHeight: number(),
        lineSpacing,
        letterSpacing,
        quantity: Number(quantitySelect.value),
        colorName: selected ? selected.dataset.name : "Matte Black",
        colorHex: selected ? selected.dataset.color : "#1f1f1f"
      })
    });
    const result = await response.json();
    if (!response.ok || !result.checkoutUrl) throw new Error(result.error || "Checkout could not be created.");
    window.location.assign(result.checkoutUrl);
  } catch (_error) {
    alert("We could not open checkout. Please try again in a moment.");
    submitButtons.forEach((button) => {
      button.disabled = false;
      button.textContent = button.dataset.originalText || "Add to Cart";
    });
  }
});

window.addEventListener("resize", update);
document.fonts?.ready.then(update);
update();
});